import Dexie from 'dexie';  // For IndexedDB interaction
import { act } from 'react';


const LOCALDB = 'LocalDB'
const WORKOUT_TABLE = 'WorkoutTable'


//LDB Initialization
const db = new Dexie(LOCALDB);

db.version(1).stores({
    [WORKOUT_TABLE]: '++id, title, start_date,start_time, end_date, exercise_title'  //schema is for only attributes that will be queried, any number and type of attributes can be added.
});

const exerciseCategories =
    [
        { exercise: "Triceps Pushdown", category: "Arms" },
        { exercise: "Triceps Extension (Cable)", category: "Arms" },
        { exercise: "Preacher Curl (Machine)", category: "Arms" },
        { exercise: "Bicep Curl (Dumbbell)", category: "Arms" },
        { exercise: "Pull Up", category: "Back" },
        { exercise: "Lat Pulldown (Cable)", category: "Back" },
        { exercise: "Single Arm Lat Pulldown", category: "Back" },
        { exercise: "Incline Bench Press (Dumbbell)", category: "Chest" },
        { exercise: "Bench Press (Dumbbell)", category: "Chest" },
        { exercise: "Butterfly (Pec Deck)", category: "Chest" },
        { exercise: "Low Cable Fly Crossovers", category: "Chest" },
        { exercise: "Hammer Curl (Dumbbell)", category: "Arms" },
        { exercise: "Triceps Dip", category: "Arms" },
        { exercise: "Seated Overhead Press (Dumbbell)", category: "Shoulders" },
        { exercise: "Lateral Raise (Cable)", category: "Shoulders" },
        { exercise: "Lateral Raise (Dumbbell)", category: "Shoulders" },
        { exercise: "Reverse Pec Deck", category: "Shoulders" },
        { exercise: "Shrug (Dumbbell)", category: "Shoulders" },
        { exercise: "Cable Crunch", category: "Core" },
        { exercise: "Leg Raise Parallel Bars", category: "Core" },
        { exercise: "Decline Bench Press (Dumbbell)", category: "Chest" },
        { exercise: "Dumbbell Row", category: "Back" },
        { exercise: "Squat (Smith Machine)", category: "Legs" },
        { exercise: "Leg Press (Machine)", category: "Legs" },
        { exercise: "Leg Extension (Machine)", category: "Legs" },
        { exercise: "Side Bend (Dumbbell)", category: "Core" },
        { exercise: "Seated Incline Curl (Dumbbell)", category: "Arms" },
        { exercise: "Front Raise (Cable)", category: "Shoulders" },
        { exercise: "Lying Leg Curl (Machine)", category: "Legs" },
        { exercise: "Seated Cable Row - Bar Grip", category: "Back" },
        { exercise: "Overhead Press (Smith Machine)", category: "Shoulders" },
        { exercise: "Squat (Barbell)", category: "Legs" },
    ];


export const exerciseListBase = {
    abdominals: [
        { exercise: "Ab Scissors", id: 1, active: false },
        { exercise: "Ab Wheel", id: 2, active: false },
        { exercise: "Bicycle Crunch", id: 3, active: false },
        { exercise: "Bicycle Crunch Raised Legs", id: 4, active: false },
        { exercise: "Cable Core Palloff Press", id: 5, active: false },
        { exercise: "Cable Crunch", id: 6, active: false },
        { exercise: "Cable Twist (Down to up)", id: 7, active: false },
        { exercise: "Cable Twist (Up to down)", id: 8, active: false },
        { exercise: "Crunch", id: 9, active: false },
        { exercise: "Crunch (Machine)", id: 10, active: false },
        { exercise: "Crunch (Weighted)", id: 11, active: false },
        { exercise: "Dead Bug", id: 12, active: false },
        { exercise: "Decline Crunch", id: 13, active: false },
        { exercise: "Decline Crunch (Weighted)", id: 14, active: false },
        { exercise: "Dragon Flag", id: 15, active: false },
        { exercise: "Dragonfly", id: 16, active: false },
        { exercise: "Elbow to Knee", id: 17, active: false },
        { exercise: "Flutter Kicks", id: 18, active: false },
        { exercise: "Front Lever Hold", id: 19, active: false },
        { exercise: "Front Lever Raise", id: 20, active: false },
        { exercise: "Hanging Knee Raise", id: 21, active: false },
        { exercise: "Hanging Leg Raise", id: 22, active: false },
        { exercise: "Heel Taps", id: 23, active: false },
        { exercise: "Hollow Rock", id: 24, active: false },
        { exercise: "Jack Knife (Suspension)", id: 25, active: false },
        { exercise: "Jackknife Sit Up", id: 26, active: false },
        { exercise: "Knee Raise Parallel Bars", id: 27, active: false },
        { exercise: "L-Sit Hold", id: 28, active: false },
        { exercise: "Landmine 180", id: 29, active: false },
        { exercise: "Leg Raise Parallel Bars", id: 30, active: false },
        { exercise: "Lying Knee Raise", id: 31, active: false },
        { exercise: "Lying Leg Raise", id: 32, active: false },
        { exercise: "Oblique Crunch", id: 33, active: false },
        { exercise: "Plank", id: 34, active: false },
        { exercise: "Reverse Crunch", id: 35, active: false },
        { exercise: "Reverse Plank", id: 36, active: false },
        { exercise: "Russian Twist (Bodyweight)", id: 37, active: false },
        { exercise: "Russian Twist (Weighted)", id: 38, active: false },
        { exercise: "Side Bend", id: 39, active: false },
        { exercise: "Side Bend (Dumbbell)", id: 40, active: false },
        { exercise: "Side Plank", id: 41, active: false },
        { exercise: "Sit Up", id: 42, active: false },
        { exercise: "Sit Up (Weighted)", id: 43, active: false },
        { exercise: "Spiderman", id: 44, active: false },
        { exercise: "Toe Touch", id: 45, active: false },
        { exercise: "Toes to Bar", id: 46, active: false },
        { exercise: "Torso Rotation", id: 47, active: false },
        { exercise: "V Up", id: 48, active: false },

    ],

    abductors: [
        { exercise: "Hip Abduction (Machine)", id: 49, active: false },
    ],

    Adductors: [
        { exercise: "Hip Adduction(Machine)", id: 50, active: false },
    ],

    biceps: [
        { exercise: "21s Bicep Curl", id: 51, active: false },
        { exercise: "Bicep Curl (Barbell)", id: 52, active: false },
        { exercise: "Bicep Curl (Cable)", id: 53, active: false },
        { exercise: "Bicep Curl (Dumbbell)", id: 54, active: false },
        { exercise: "Bicep Curl (Machine)", id: 55, active: false },
        { exercise: "Bicep Curl (Suspension)", id: 56, active: false },
        { exercise: "Concentration Curl", id: 57, active: false },
        { exercise: "Cross Body Hammer Curl", id: 58, active: false },
        { exercise: "Drag Curl", id: 59, active: false },
        { exercise: "EZ Bar Biceps Curl", id: 60, active: false },
        { exercise: "Hammer Curl (Band)", id: 61, active: false },
        { exercise: "Hammer Curl (Cable)", id: 62, active: false },
        { exercise: "Hammer Curl (Dumbbell)", id: 63, active: false },
        { exercise: "Kettlebell Curl", id: 64, active: false },
        { exercise: "Overhead Curl (Cable)", id: 65, active: false },
        { exercise: "Pinwheel Curl (Dumbbell)", id: 66, active: false },
        { exercise: "Plate Curl", id: 67, active: false },
        { exercise: "Preacher Curl (Barbell)", id: 68, active: false },
        { exercise: "Preacher Curl (Dumbbell)", id: 69, active: false },
        { exercise: "Preacher Curl (Machine)", id: 70, active: false },
        { exercise: "Reverse Curl (Barbell)", id: 71, active: false },
        { exercise: "Reverse Curl (Cable)", id: 72, active: false },
        { exercise: "Reverse Curl (Dumbbell)", id: 73, active: false },
        { exercise: "Reverse Grip Concentration Curl", id: 74, active: false },
        { exercise: "Rope Cable Curl", id: 75, active: false },
        { exercise: "Seated Incline Curl (Dumbbell)", id: 76, active: false },
        { exercise: "Single Arm Curl (Cable)", id: 77, active: false },
        { exercise: "Spider Curl (Barbell)", id: 78, active: false },
        { exercise: "Spider Curl (Dumbbell)", id: 79, active: false },
        { exercise: "Zottman Curl (Dumbbell)", id: 80, active: false },
    ],

    lower_back: [
        { exercise: "Back Extension (Hyperextension)", id: 81, active: false },
        { exercise: "Back Extension (Machine)", id: 82, active: false },
        { exercise: "Back Extension (Weighted Hyperextension)", id: 83, active: false },
        { exercise: "Rack Pull", id: 84, active: false },
        { exercise: "Superman", id: 85, active: false },


    ],

    upper_back: [
        { exercise: "Bent Over Row (Band)", id: 86, active: false },
        { exercise: "Bent Over Row (Barbell)", id: 87, active: false },
        { exercise: "Bent Over Row (Dumbbell)", id: 88, active: false },
        { exercise: "Chest Supported Incline Row (Dumbbell)", id: 89, active: false },
        { exercise: "Chest Supported Reverse Fly (Dumbbell)", id: 90, active: false },
        { exercise: "Dead Hang", id: 91, active: false },
        { exercise: "Dumbbell Row", id: 92, active: false },
        { exercise: "Gorilla Row (Kettlebell)", id: 93, active: false },
        { exercise: "Inverted Row", id: 94, active: false },
        { exercise: "Landmine Row", id: 95, active: false },
        { exercise: "Low Row (Suspension)", id: 96, active: false },
        { exercise: "Meadows Rows (Barbell)", id: 97, active: false },
        { exercise: "Pendlay Row (Barbell)", id: 98, active: false },
        { exercise: "Rear Delt Reverse Fly (Cable)", id: 99, active: false },
        { exercise: "Rear Delt Reverse Fly (Dumbbell)", id: 100, active: false },
        { exercise: "Rear Delt Reverse Fly (Machine)", id: 101, active: false },
        { exercise: "Renegade Row (Dumbbell)", id: 102, active: false },
        { exercise: "Reverse Fly Single Arm (Cable)", id: 103, active: false },
        { exercise: "Reverse Grip Lat Pulldown (Cable)", id: 104, active: false },
        { exercise: "Scapular Pull Ups", id: 105, active: false },
        { exercise: "Seated Cable Row - Bar Grip", id: 106, active: false },
        { exercise: "Seated Cable Row - Bar Wide Grip", id: 107, active: false },
        { exercise: "Seated Cable Row - V Grip (Cable)", id: 108, active: false },
        { exercise: "Seated Row (Machine)", id: 109, active: false },
        { exercise: "Single Arm Cable Row", id: 110, active: false },
        { exercise: "T Bar Row", id: 111, active: false }

    ],

    cardio: [
        { exercise: "Aerobics", id: 112, active: false },
        { exercise: "Air Bike", id: 113, active: false },
        { exercise: "Battle Ropes", id: 114, active: false },
        { exercise: "Boxing", id: 115, active: false },
        { exercise: "Climbing", id: 116, active: false },
        { exercise: "Cycling", id: 117, active: false },
        { exercise: "Elliptical Trainer", id: 118, active: false },
        { exercise: "HIIT", id: 119, active: false },
        { exercise: "Hiking", id: 120, active: false },
        { exercise: "Jump Rope", id: 121, active: false },
        { exercise: "Rowing Machine", id: 122, active: false },
        { exercise: "Running", id: 123, active: false },
        { exercise: "Skating", id: 124, active: false },
        { exercise: "Skiing", id: 125, active: false },
        { exercise: "Snowboarding", id: 126, active: false },
        { exercise: "Spinning", id: 127, active: false },
        { exercise: "Sprints", id: 128, active: false },
        { exercise: "Stair Machine", id: 129, active: false },
        { exercise: "Swimming", id: 130, active: false },
        { exercise: "Treadmill", id: 131, active: false },
        { exercise: "Walking", id: 132, active: false }

    ],

    chest: [
        { exercise: "Around The World", id: 133, active: false },
        { exercise: "Bench Press (Barbell)", id: 134, active: false },
        { exercise: "Bench Press (Cable)", id: 135, active: false },
        { exercise: "Bench Press (Dumbbell)", id: 136, active: false },
        { exercise: "Bench Press (Smith Machine)", id: 137, active: false },
        { exercise: "Bench Press - Wide Grip (Barbell)", id: 138, active: false },
        { exercise: "Butterfly (Pec Deck)", id: 139, active: false },
        { exercise: "Cable Fly Crossovers", id: 140, active: false },
        { exercise: "Chest Dip", id: 141, active: false },
        { exercise: "Chest Dip (Assisted)", id: 142, active: false },
        { exercise: "Chest Dip (Weighted)", id: 143, active: false },
        { exercise: "Chest Fly (Band)", id: 144, active: false },
        { exercise: "Chest Fly (Dumbbell)", id: 145, active: false },
        { exercise: "Chest Fly (Machine)", id: 146, active: false },
        { exercise: "Chest Fly (Suspension)", id: 147, active: false },
        { exercise: "Chest Press (Band)", id: 148, active: false },
        { exercise: "Chest Press (Machine)", id: 149, active: false },
        { exercise: "Clap Push Ups", id: 150, active: false },
        { exercise: "Decline Bench Press (Barbell)", id: 151, active: false },
        { exercise: "Decline Bench Press (Dumbbell)", id: 152, active: false },
        { exercise: "Decline Bench Press (Machine)", id: 153, active: false },
        { exercise: "Decline Bench Press (Smith Machine)", id: 154, active: false },
        { exercise: "Decline Chest Fly (Dumbbell)", id: 155, active: false },
        { exercise: "Decline Push Up", id: 156, active: false },
        { exercise: "Dumbbell Squeeze Press", id: 157, active: false },
        { exercise: "Floor Press (Barbell)", id: 158, active: false },
        { exercise: "Floor Press (Dumbbell)", id: 159, active: false },
        { exercise: "Hex Press (Dumbbell)", id: 160, active: false },
        { exercise: "Incline Bench Press (Barbell)", id: 161, active: false },
        { exercise: "Incline Bench Press (Dumbbell)", id: 162, active: false },
        { exercise: "Incline Bench Press (Smith Machine)", id: 163, active: false },
        { exercise: "Incline Chest Fly (Dumbbell)", id: 164, active: false },
        { exercise: "Incline Chest Press (Machine)", id: 165, active: false },
        { exercise: "Incline Push Ups", id: 166, active: false },
        { exercise: "Iso-Lateral Chest Press (Machine)", id: 167, active: false },
        { exercise: "Kneeling Push Up", id: 168, active: false },
        { exercise: "Low Cable Fly Crossovers", id: 169, active: false },
        { exercise: "Plank Pushup", id: 170, active: false },
        { exercise: "Plate Press", id: 171, active: false },
        { exercise: "Plate Squeeze (Svend Press)", id: 172, active: false },
        { exercise: "Pullover (Dumbbell)", id: 173, active: false },
        { exercise: "Pullover (Machine)", id: 174, active: false },
        { exercise: "Push Up", id: 175, active: false },
        { exercise: "Push Up (Weighted)", id: 176, active: false },
        { exercise: "Push Up - Close Grip", id: 177, active: false },
        { exercise: "Seated Chest Flys (Cable)", id: 178, active: false },
        { exercise: "Single Arm Cable Crossover", id: 179, active: false }
    ],

    calves: [
        { exercise: "Calf Extension (Machine)", id: 180, active: false },
        { exercise: "Calf Press (Machine)", id: 181, active: false },
        { exercise: "Seated Calf Raise", id: 182, active: false },
        { exercise: "Single Leg Standing Calf Raise", id: 183, active: false },
        { exercise: "Single Leg Standing Calf Raise (Barbell)", id: 184, active: false },
        { exercise: "Single Leg Standing Calf Raise (Dumbbell)", id: 185, active: false },
        { exercise: "Single Leg Standing Calf Raise (Machine)", id: 186, active: false },
        { exercise: "Standing Calf Raise", id: 187, active: false },
        { exercise: "Standing Calf Raise (Barbell)", id: 188, active: false },
        { exercise: "Standing Calf Raise (Dumbbell)", id: 189, active: false },
        { exercise: "Standing Calf Raise (Machine)", id: 190, active: false },
        { exercise: "Standing Calf Raise (Smith)", id: 191, active: false }
    ],

    forearms: [
        { exercise: "Behind the Back Bicep Wrist Curl (Barbell)", id: 192, active: false },
        { exercise: "Seated Palms Up Wrist Curl", id: 193, active: false },
        { exercise: "Seated Wrist Extension (Barbell)", id: 194, active: false },
        { exercise: "Wrist Roller", id: 195, active: false }
    ],

    glutes: [
        { exercise: "Bird Dog", id: 196, active: false },
        { exercise: "Cable Pull Through", id: 197, active: false },
        { exercise: "Clamshell", id: 198, active: false },
        { exercise: "Fire Hydrants", id: 199, active: false },
        { exercise: "Frog Pumps (Dumbbell)", id: 200, active: false },
        { exercise: "Glute Bridge", id: 201, active: false },
        { exercise: "Glute Kickback (Machine)", id: 202, active: false },
        { exercise: "Glute Kickback on Floor", id: 203, active: false },
        { exercise: "High Knees", id: 204, active: false },
        { exercise: "Hip Thrust", id: 205, active: false },
        { exercise: "Hip Thrust (Barbell)", id: 206, active: false },
        { exercise: "Hip Thrust (Machine)", id: 207, active: false },
        { exercise: "Lateral Band Walks", id: 208, active: false },
        { exercise: "Lateral Leg Raises", id: 209, active: false },
        { exercise: "Reverse Hyperextension", id: 210, active: false },
        { exercise: "Single Leg Glute Bridge", id: 211, active: false },
        { exercise: "Single Leg Hip Thrust", id: 212, active: false },
        { exercise: "Single Leg Hip Thrust (Dumbbell)", id: 213, active: false },
        { exercise: "Standing Cable Glute Kickbacks", id: 214, active: false }
    ],

    hamstrings: [
        { exercise: "Deadlift (Band)", id: 215, active: false },
        { exercise: "Deadlift (Barbell)", id: 216, active: false },
        { exercise: "Deadlift (Dumbbell)", id: 217, active: false },
        { exercise: "Deadlift (Smith Machine)", id: 218, active: false },
        { exercise: "Deadlift (Trap bar)", id: 219, active: false },
        { exercise: "Glute Ham Raise", id: 220, active: false },
        { exercise: "Good Morning (Barbell)", id: 221, active: false },
        { exercise: "Lying Leg Curl (Machine)", id: 222, active: false },
        { exercise: "Nordic Hamstrings Curls", id: 223, active: false },
        { exercise: "Reverse Lunge (Dumbbell)", id: 224, active: false },
        { exercise: "Romanian Deadlift (Barbell)", id: 225, active: false },
        { exercise: "Romanian Deadlift (Dumbbell)", id: 226, active: false },
        { exercise: "Seated Leg Curl (Machine)", id: 227, active: false },
        { exercise: "Single Leg Romanian Deadlift (Barbell)", id: 228, active: false },
        { exercise: "Single Leg Romanian Deadlift (Dumbbell)", id: 229, active: false },
        { exercise: "Standing Leg Curls", id: 230, active: false },
        { exercise: "Straight Leg Deadlift", id: 231, active: false },
        { exercise: "Sumo Deadlift", id: 232, active: false }
    ],

    lats: [
        { exercise: "Chin Up", id: 233, active: false },
        { exercise: "Chin Up (Assisted)", id: 234, active: false },
        { exercise: "Chin Up (Weighted)", id: 235, active: false },
        { exercise: "Iso-Lateral High Row (Machine)", id: 236, active: false },
        { exercise: "Iso-Lateral Low Row", id: 237, active: false },
        { exercise: "Iso-Lateral Row (Machine)", id: 238, active: false },
        { exercise: "Kipping Pull Up", id: 239, active: false },
        { exercise: "Kneeling Pulldown (band)", id: 240, active: false },
        { exercise: "Lat Pulldown (Band)", id: 241, active: false },
        { exercise: "Lat Pulldown (Cable)", id: 242, active: false },
        { exercise: "Lat Pulldown (Machine)", id: 243, active: false },
        { exercise: "Lat Pulldown - Close Grip (Cable)", id: 244, active: false },
        { exercise: "Negative Pull Up", id: 245, active: false },
        { exercise: "Pull Up", id: 246, active: false },
        { exercise: "Pull Up (Assisted)", id: 247, active: false },
        { exercise: "Pull Up (Band)", id: 248, active: false },
        { exercise: "Pull Up (Weighted)", id: 249, active: false },
        { exercise: "Rope Straight Arm Pulldown", id: 250, active: false },
        { exercise: "Single Arm Lat Pulldown", id: 251, active: false },
        { exercise: "Sternum Pull up (Gironda)", id: 252, active: false },
        { exercise: "Straight Arm Lat Pulldown (Cable)", id: 253, active: false },
        { exercise: "Wide Pull Up", id: 254, active: false },
    ],

    quadriceps: [
        { exercise: "Assisted Pistol Squats", id: 273, active: false },
        { exercise: "Box Jump", id: 274, active: false },
        { exercise: "Box Squat (Barbell)", id: 275, active: false },
        { exercise: "Bulgarian Split Squat", id: 276, active: false },
        { exercise: "Curtsy Lunge (Dumbbell)", id: 277, active: false },
        { exercise: "Dumbbell Step Up", id: 278, active: false },
        { exercise: "Front Squat", id: 279, active: false },
        { exercise: "Full Squat", id: 280, active: false },
        { exercise: "Goblet Squat", id: 281, active: false },
        { exercise: "Hack Squat", id: 282, active: false },
        { exercise: "Hack Squat (Machine)", id: 283, active: false },
        { exercise: "High Knee Skips", id: 284, active: false },
        { exercise: "Jump Squat", id: 285, active: false },
        { exercise: "Jumping Lunge", id: 286, active: false },
        { exercise: "Kettlebell Goblet Squat", id: 287, active: false },
        { exercise: "Lateral Box Jump", id: 288, active: false },
        { exercise: "Lateral Lunge", id: 289, active: false },
        { exercise: "Lateral Squat", id: 290, active: false },
        { exercise: "Leg Extension (Machine)", id: 291, active: false },
        { exercise: "Leg Press (Machine)", id: 292, active: false },
        { exercise: "Leg Press Horizontal (Machine)", id: 293, active: false },
        { exercise: "Lunge", id: 294, active: false },
        { exercise: "Lunge (Barbell)", id: 295, active: false },
        { exercise: "Lunge (Dumbbell)", id: 296, active: false },
        { exercise: "Overhead Dumbbell Lunge", id: 297, active: false },
        { exercise: "Pause Squat (Barbell)", id: 298, active: false },
        { exercise: "Pendulum Squat (Machine)", id: 299, active: false },
        { exercise: "Pistol Squat", id: 300, active: false },
        { exercise: "Reverse Lunge", id: 301, active: false },
        { exercise: "Reverse Lunge (Barbell)", id: 302, active: false },
        { exercise: "Single Leg Extensions", id: 303, active: false },
        { exercise: "Single Leg Press (Machine)", id: 304, active: false },
        { exercise: "Sissy Squat (Weighted)", id: 305, active: false },
        { exercise: "Split Squat (Dumbbell)", id: 306, active: false },
        { exercise: "Squat (Band)", id: 307, active: false },
        { exercise: "Squat (Barbell)", id: 308, active: false },
        { exercise: "Squat (Bodyweight)", id: 309, active: false },
        { exercise: "Squat (Dumbbell)", id: 310, active: false },
        { exercise: "Squat (Machine)", id: 311, active: false },
        { exercise: "Squat (Smith Machine)", id: 312, active: false },
        { exercise: "Squat (Suspension)", id: 313, active: false },
        { exercise: "Step Up", id: 314, active: false },
        { exercise: "Sumo Squat", id: 315, active: false },
        { exercise: "Sumo Squat (Barbell)", id: 316, active: false },
        { exercise: "Sumo Squat (Dumbbell)", id: 317, active: false },
        { exercise: "Sumo Squat (Kettlebell)", id: 318, active: false },
        { exercise: "Walking Lunge", id: 319, active: false },
        { exercise: "Walking Lunge (Dumbbell)", id: 320, active: false },
        { exercise: "Wall Sit", id: 321, active: false },
        { exercise: "Zercher Squat", id: 322, active: false },
    ],

    shoulders: [
        { exercise: "Arnold Press (Dumbbell)", id: 323, active: false },
        { exercise: "Band Pullaparts", id: 324, active: false },
        { exercise: "Chest Supported Y Raise (Dumbbell)", id: 325, active: false },
        { exercise: "Face Pull", id: 326, active: false },
        { exercise: "Front Raise (Band)", id: 327, active: false },
        { exercise: "Front Raise (Barbell)", id: 328, active: false },
        { exercise: "Front Raise (Cable)", id: 329, active: false },
        { exercise: "Front Raise (Dumbbell)", id: 330, active: false },
        { exercise: "Front Raise (Suspension)", id: 331, active: false },
        { exercise: "Handstand Push Up", id: 332, active: false },
        { exercise: "Lateral Raise (Band)", id: 333, active: false },
        { exercise: "Lateral Raise (Cable)", id: 334, active: false },
        { exercise: "Lateral Raise (Dumbbell)", id: 335, active: false },
        { exercise: "Lateral Raise (Machine)", id: 336, active: false },
        { exercise: "Overhead Press (Barbell)", id: 337, active: false },
        { exercise: "Overhead Press (Dumbbell)", id: 338, active: false },
        { exercise: "Overhead Press (Smith Machine)", id: 339, active: false },
        { exercise: "Plate Front Raise", id: 340, active: false },
        { exercise: "Push Press", id: 341, active: false },
        { exercise: "Reverse Pec Deck", id: 342, active: false },
        { exercise: "Seated Lateral Raise (Dumbbell)", id: 343, active: false },
        { exercise: "Seated Overhead Press (Barbell)", id: 344, active: false },
        { exercise: "Seated Overhead Press (Dumbbell)", id: 345, active: false },
        { exercise: "Seated Shoulder Press (Machine)", id: 346, active: false },
        { exercise: "Shoulder Press (Dumbbell)", id: 347, active: false },
        { exercise: "Shoulder Press (Machine Plates)", id: 348, active: false },
        { exercise: "Shoulder Taps", id: 349, active: false },
        { exercise: "Shrug", id: 350, active: false },
        { exercise: "Single Arm Landmine Press (Barbell)", id: 351, active: false },
        { exercise: "Single Arm Lateral Raise (Cable)", id: 352, active: false },
        { exercise: "Standing Military Press (Barbell)", id: 353, active: false },
        { exercise: "Upright Row (Cable)", id: 354, active: false },
        { exercise: "Upright Row (Dumbbell)", id: 355, active: false },
    ],

    triceps: [
        { exercise: "Bench Dip", id: 356, active: false },
        { exercise: "Bench Press - Close Grip (Barbell)", id: 357, active: false },
        { exercise: "Diamond Push Up", id: 358, active: false },
        { exercise: "Floor Triceps Dip", id: 359, active: false },
        { exercise: "JM Press (Barbell)", id: 360, active: false },
        { exercise: "Pike Pushup", id: 361, active: false },
        { exercise: "Ring Dips", id: 362, active: false },
        { exercise: "Seated Dip Machine", id: 363, active: false },
        { exercise: "Seated Triceps Press", id: 364, active: false },
        { exercise: "Single Arm Tricep Extension (Dumbbell)", id: 365, active: false },
        { exercise: "Single Arm Triceps Pushdown (Cable)", id: 366, active: false },
        { exercise: "Skullcrusher (Barbell)", id: 367, active: false },
        { exercise: "Skullcrusher (Dumbbell)", id: 368, active: false },
        { exercise: "Triceps Dip", id: 369, active: false },
        { exercise: "Triceps Dip (Assisted)", id: 370, active: false },
        { exercise: "Triceps Dip (Weighted)", id: 371, active: false },
        { exercise: "Triceps Extension (Barbell)", id: 372, active: false },
        { exercise: "Triceps Extension (Cable)", id: 373, active: false },
        { exercise: "Triceps Extension (Dumbbell)", id: 374, active: false },
        { exercise: "Triceps Extension (Machine)", id: 375, active: false },
        { exercise: "Triceps Extension (Suspension)", id: 376, active: false },
        { exercise: "Triceps Kickback (Cable)", id: 377, active: false },
        { exercise: "Triceps Kickback (Dumbbell)", id: 378, active: false },
        { exercise: "Triceps Pressdown", id: 379, active: false },
        { exercise: "Triceps Pushdown", id: 380, active: false },
        { exercise: "Triceps Rope Pushdown", id: 381, active: false },
    ],

    traps: [
        { exercise: "Shrug (Barbell)", id: 382, active: false },
        { exercise: "Shrug (Cable)", id: 383, active: false },
        { exercise: "Shrug (Dumbbell)", id: 384, active: false },
        { exercise: "Shrug (Machine)", id: 385, active: false },
        { exercise: "Shrug (Smith Machine)", id: 386, active: false },
        { exercise: "Upright Row (Barbell)", id: 387, active: false },
    ],

    neck: [
        { exercise: "Lying Neck Curls", id: 388, active: false },
        { exercise: "Lying Neck Curls (Weighted)", id: 389, active: false },
        { exercise: "Lying Neck Extension", id: 390, active: false },
        { exercise: "Lying Neck Extension (Weighted)", id: 391, active: false },
    ],

    full_body: [
        { exercise: "Ball Slams", id: 392, active: false },
        { exercise: "Burpee", id: 393, active: false },
        { exercise: "Burpee Over the Bar", id: 394, active: false },
        { exercise: "Clean", id: 395, active: false },
        { exercise: "Clean and Jerk", id: 396, active: false },
        { exercise: "Clean and Press", id: 397, active: false },
        { exercise: "Clean Pull", id: 398, active: false },
        { exercise: "Deadlift High Pull", id: 399, active: false },
        { exercise: "Downward Dog", id: 400, active: false },
        { exercise: "Dumbbell Snatch", id: 401, active: false },
        { exercise: "Farmers Walk", id: 402, active: false },
        { exercise: "Frog Jumps", id: 403, active: false },
        { exercise: "Handstand Hold", id: 404, active: false },
        { exercise: "Hang Clean", id: 405, active: false },
        { exercise: "Hang Snatch", id: 406, active: false },
        { exercise: "Jump Shrug", id: 407, active: false },
        { exercise: "Jumping Jack", id: 408, active: false },
        { exercise: "Kettlebell Clean", id: 409, active: false },
        { exercise: "Kettlebell High Pull", id: 410, active: false },
        { exercise: "Kettlebell Shoulder Press", id: 411, active: false },
        { exercise: "Kettlebell Snatch", id: 412, active: false },
        { exercise: "Kettlebell Swing", id: 413, active: false },
        { exercise: "Kettlebell Turkish Get Up", id: 414, active: false },
        { exercise: "Landmine Squat and Press", id: 415, active: false },
        { exercise: "Mountain Climber", id: 416, active: false },
        { exercise: "Muscle Up", id: 417, active: false },
        { exercise: "One Arm Push Up", id: 418, active: false },
        { exercise: "Overhead Squat", id: 419, active: false },
        { exercise: "Pilates", id: 420, active: false },
        { exercise: "Power Clean", id: 421, active: false },
        { exercise: "Power Snatch", id: 422, active: false },
        { exercise: "Press Under", id: 423, active: false },
        { exercise: "Sled Push", id: 424, active: false },
        { exercise: "Snatch", id: 425, active: false },
        { exercise: "Split Jerk", id: 426, active: false },
        { exercise: "Squat Row", id: 427, active: false },
        { exercise: "Thruster (Barbell)", id: 428, active: false },
        { exercise: "Thruster (Kettlebell)", id: 429, active: false },
        { exercise: "Wall Ball", id: 430, active: false },
        { exercise: "Warm Up", id: 431, active: false },
        { exercise: "Yoga", id: 432, active: false },
    ],

    other: [
        { exercise: "Stretching", id: 433, active: false },
    ],


}

export const exerciseListBase2 = {
    back: {
        lower_back: [
            { exercise: "Back Extension (Hyperextension)", id: 81, active: false },
            { exercise: "Back Extension (Machine)", id: 82, active: false },
            { exercise: "Back Extension (Weighted Hyperextension)", id: 83, active: false },
            { exercise: "Rack Pull", id: 84, active: false },
            { exercise: "Superman", id: 85, active: false },


        ],

        upper_back: [
            { exercise: "Bent Over Row (Band)", id: 86, active: false },
            { exercise: "Bent Over Row (Barbell)", id: 87, active: false },
            { exercise: "Bent Over Row (Dumbbell)", id: 88, active: false },
            { exercise: "Chest Supported Incline Row (Dumbbell)", id: 89, active: false },
            { exercise: "Chest Supported Reverse Fly (Dumbbell)", id: 90, active: false },
            { exercise: "Dead Hang", id: 91, active: false },
            { exercise: "Dumbbell Row", id: 92, active: false },
            { exercise: "Gorilla Row (Kettlebell)", id: 93, active: false },
            { exercise: "Inverted Row", id: 94, active: false },
            { exercise: "Landmine Row", id: 95, active: false },
            { exercise: "Low Row (Suspension)", id: 96, active: false },
            { exercise: "Meadows Rows (Barbell)", id: 97, active: false },
            { exercise: "Pendlay Row (Barbell)", id: 98, active: false },
            { exercise: "Rear Delt Reverse Fly (Cable)", id: 99, active: false },
            { exercise: "Rear Delt Reverse Fly (Dumbbell)", id: 100, active: false },
            { exercise: "Rear Delt Reverse Fly (Machine)", id: 101, active: false },
            { exercise: "Renegade Row (Dumbbell)", id: 102, active: false },
            { exercise: "Reverse Fly Single Arm (Cable)", id: 103, active: false },
            { exercise: "Reverse Grip Lat Pulldown (Cable)", id: 104, active: false },
            { exercise: "Scapular Pull Ups", id: 105, active: false },
            { exercise: "Seated Cable Row - Bar Grip", id: 106, active: false },
            { exercise: "Seated Cable Row - Bar Wide Grip", id: 107, active: false },
            { exercise: "Seated Cable Row - V Grip (Cable)", id: 108, active: false },
            { exercise: "Seated Row (Machine)", id: 109, active: false },
            { exercise: "Single Arm Cable Row", id: 110, active: false },
            { exercise: "T Bar Row", id: 111, active: false }

        ],

        lats: [
            { exercise: "Chin Up", id: 233, active: false },
            { exercise: "Chin Up (Assisted)", id: 234, active: false },
            { exercise: "Chin Up (Weighted)", id: 235, active: false },
            { exercise: "Iso-Lateral High Row (Machine)", id: 236, active: false },
            { exercise: "Iso-Lateral Low Row", id: 237, active: false },
            { exercise: "Iso-Lateral Row (Machine)", id: 238, active: false },
            { exercise: "Kipping Pull Up", id: 239, active: false },
            { exercise: "Kneeling Pulldown (band)", id: 240, active: false },
            { exercise: "Lat Pulldown (Band)", id: 241, active: false },
            { exercise: "Lat Pulldown (Cable)", id: 242, active: false },
            { exercise: "Lat Pulldown (Machine)", id: 243, active: false },
            { exercise: "Lat Pulldown - Close Grip (Cable)", id: 244, active: false },
            { exercise: "Negative Pull Up", id: 245, active: false },
            { exercise: "Pull Up", id: 246, active: false },
            { exercise: "Pull Up (Assisted)", id: 247, active: false },
            { exercise: "Pull Up (Band)", id: 248, active: false },
            { exercise: "Pull Up (Weighted)", id: 249, active: false },
            { exercise: "Rope Straight Arm Pulldown", id: 250, active: false },
            { exercise: "Single Arm Lat Pulldown", id: 251, active: false },
            { exercise: "Sternum Pull up (Gironda)", id: 252, active: false },
            { exercise: "Straight Arm Lat Pulldown (Cable)", id: 253, active: false },
            { exercise: "Wide Pull Up", id: 254, active: false },
        ],

        traps: [
            { exercise: "Shrug (Barbell)", id: 382, active: false },
            { exercise: "Shrug (Cable)", id: 383, active: false },
            { exercise: "Shrug (Dumbbell)", id: 384, active: false },
            { exercise: "Shrug (Machine)", id: 385, active: false },
            { exercise: "Shrug (Smith Machine)", id: 386, active: false },
            { exercise: "Upright Row (Barbell)", id: 387, active: false },
        ],




    },

    arms: {
        triceps: [
            { exercise: "Bench Dip", id: 356, active: false },
            { exercise: "Bench Press - Close Grip (Barbell)", id: 357, active: false },
            { exercise: "Diamond Push Up", id: 358, active: false },
            { exercise: "Floor Triceps Dip", id: 359, active: false },
            { exercise: "JM Press (Barbell)", id: 360, active: false },
            { exercise: "Pike Pushup", id: 361, active: false },
            { exercise: "Ring Dips", id: 362, active: false },
            { exercise: "Seated Dip Machine", id: 363, active: false },
            { exercise: "Seated Triceps Press", id: 364, active: false },
            { exercise: "Single Arm Tricep Extension (Dumbbell)", id: 365, active: false },
            { exercise: "Single Arm Triceps Pushdown (Cable)", id: 366, active: false },
            { exercise: "Skullcrusher (Barbell)", id: 367, active: false },
            { exercise: "Skullcrusher (Dumbbell)", id: 368, active: false },
            { exercise: "Triceps Dip", id: 369, active: false },
            { exercise: "Triceps Dip (Assisted)", id: 370, active: false },
            { exercise: "Triceps Dip (Weighted)", id: 371, active: false },
            { exercise: "Triceps Extension (Barbell)", id: 372, active: false },
            { exercise: "Triceps Extension (Cable)", id: 373, active: false },
            { exercise: "Triceps Extension (Dumbbell)", id: 374, active: false },
            { exercise: "Triceps Extension (Machine)", id: 375, active: false },
            { exercise: "Triceps Extension (Suspension)", id: 376, active: false },
            { exercise: "Triceps Kickback (Cable)", id: 377, active: false },
            { exercise: "Triceps Kickback (Dumbbell)", id: 378, active: false },
            { exercise: "Triceps Pressdown", id: 379, active: false },
            { exercise: "Triceps Pushdown", id: 380, active: false },
            { exercise: "Triceps Rope Pushdown", id: 381, active: false },
        ],

        biceps: [
            { exercise: "21s Bicep Curl", id: 51, active: false },
            { exercise: "Bicep Curl (Barbell)", id: 52, active: false },
            { exercise: "Bicep Curl (Cable)", id: 53, active: false },
            { exercise: "Bicep Curl (Dumbbell)", id: 54, active: false },
            { exercise: "Bicep Curl (Machine)", id: 55, active: false },
            { exercise: "Bicep Curl (Suspension)", id: 56, active: false },
            { exercise: "Concentration Curl", id: 57, active: false },
            { exercise: "Cross Body Hammer Curl", id: 58, active: false },
            { exercise: "Drag Curl", id: 59, active: false },
            { exercise: "EZ Bar Biceps Curl", id: 60, active: false },
            { exercise: "Hammer Curl (Band)", id: 61, active: false },
            { exercise: "Hammer Curl (Cable)", id: 62, active: false },
            { exercise: "Hammer Curl (Dumbbell)", id: 63, active: false },
            { exercise: "Kettlebell Curl", id: 64, active: false },
            { exercise: "Overhead Curl (Cable)", id: 65, active: false },
            { exercise: "Pinwheel Curl (Dumbbell)", id: 66, active: false },
            { exercise: "Plate Curl", id: 67, active: false },
            { exercise: "Preacher Curl (Barbell)", id: 68, active: false },
            { exercise: "Preacher Curl (Dumbbell)", id: 69, active: false },
            { exercise: "Preacher Curl (Machine)", id: 70, active: false },
            { exercise: "Reverse Curl (Barbell)", id: 71, active: false },
            { exercise: "Reverse Curl (Cable)", id: 72, active: false },
            { exercise: "Reverse Curl (Dumbbell)", id: 73, active: false },
            { exercise: "Reverse Grip Concentration Curl", id: 74, active: false },
            { exercise: "Rope Cable Curl", id: 75, active: false },
            { exercise: "Seated Incline Curl (Dumbbell)", id: 76, active: false },
            { exercise: "Single Arm Curl (Cable)", id: 77, active: false },
            { exercise: "Spider Curl (Barbell)", id: 78, active: false },
            { exercise: "Spider Curl (Dumbbell)", id: 79, active: false },
            { exercise: "Zottman Curl (Dumbbell)", id: 80, active: false },
        ],

        forearms: [
            { exercise: "Behind the Back Bicep Wrist Curl (Barbell)", id: 192, active: false },
            { exercise: "Seated Palms Up Wrist Curl", id: 193, active: false },
            { exercise: "Seated Wrist Extension (Barbell)", id: 194, active: false },
            { exercise: "Wrist Roller", id: 195, active: false }
        ],
    },

    chest: {

        chest: [
            { exercise: "Around The World", id: 133, active: false },
            { exercise: "Bench Press (Barbell)", id: 134, active: false },
            { exercise: "Bench Press (Cable)", id: 135, active: false },
            { exercise: "Bench Press (Dumbbell)", id: 136, active: false },
            { exercise: "Bench Press (Smith Machine)", id: 137, active: false },
            { exercise: "Bench Press - Wide Grip (Barbell)", id: 138, active: false },
            { exercise: "Butterfly (Pec Deck)", id: 139, active: false },
            { exercise: "Cable Fly Crossovers", id: 140, active: false },
            { exercise: "Chest Dip", id: 141, active: false },
            { exercise: "Chest Dip (Assisted)", id: 142, active: false },
            { exercise: "Chest Dip (Weighted)", id: 143, active: false },
            { exercise: "Chest Fly (Band)", id: 144, active: false },
            { exercise: "Chest Fly (Dumbbell)", id: 145, active: false },
            { exercise: "Chest Fly (Machine)", id: 146, active: false },
            { exercise: "Chest Fly (Suspension)", id: 147, active: false },
            { exercise: "Chest Press (Band)", id: 148, active: false },
            { exercise: "Chest Press (Machine)", id: 149, active: false },
            { exercise: "Clap Push Ups", id: 150, active: false },
            { exercise: "Decline Bench Press (Barbell)", id: 151, active: false },
            { exercise: "Decline Bench Press (Dumbbell)", id: 152, active: false },
            { exercise: "Decline Bench Press (Machine)", id: 153, active: false },
            { exercise: "Decline Bench Press (Smith Machine)", id: 154, active: false },
            { exercise: "Decline Chest Fly (Dumbbell)", id: 155, active: false },
            { exercise: "Decline Push Up", id: 156, active: false },
            { exercise: "Dumbbell Squeeze Press", id: 157, active: false },
            { exercise: "Floor Press (Barbell)", id: 158, active: false },
            { exercise: "Floor Press (Dumbbell)", id: 159, active: false },
            { exercise: "Hex Press (Dumbbell)", id: 160, active: false },
            { exercise: "Incline Bench Press (Barbell)", id: 161, active: false },
            { exercise: "Incline Bench Press (Dumbbell)", id: 162, active: false },
            { exercise: "Incline Bench Press (Smith Machine)", id: 163, active: false },
            { exercise: "Incline Chest Fly (Dumbbell)", id: 164, active: false },
            { exercise: "Incline Chest Press (Machine)", id: 165, active: false },
            { exercise: "Incline Push Ups", id: 166, active: false },
            { exercise: "Iso-Lateral Chest Press (Machine)", id: 167, active: false },
            { exercise: "Kneeling Push Up", id: 168, active: false },
            { exercise: "Low Cable Fly Crossovers", id: 169, active: false },
            { exercise: "Plank Pushup", id: 170, active: false },
            { exercise: "Plate Press", id: 171, active: false },
            { exercise: "Plate Squeeze (Svend Press)", id: 172, active: false },
            { exercise: "Pullover (Dumbbell)", id: 173, active: false },
            { exercise: "Pullover (Machine)", id: 174, active: false },
            { exercise: "Push Up", id: 175, active: false },
            { exercise: "Push Up (Weighted)", id: 176, active: false },
            { exercise: "Push Up - Close Grip", id: 177, active: false },
            { exercise: "Seated Chest Flys (Cable)", id: 178, active: false },
            { exercise: "Single Arm Cable Crossover", id: 179, active: false }
        ],
    },

    shoulder: {

        shoulders: [
            { exercise: "Arnold Press (Dumbbell)", id: 323, active: false },
            { exercise: "Band Pullaparts", id: 324, active: false },
            { exercise: "Chest Supported Y Raise (Dumbbell)", id: 325, active: false },
            { exercise: "Face Pull", id: 326, active: false },
            { exercise: "Front Raise (Band)", id: 327, active: false },
            { exercise: "Front Raise (Barbell)", id: 328, active: false },
            { exercise: "Front Raise (Cable)", id: 329, active: false },
            { exercise: "Front Raise (Dumbbell)", id: 330, active: false },
            { exercise: "Front Raise (Suspension)", id: 331, active: false },
            { exercise: "Handstand Push Up", id: 332, active: false },
            { exercise: "Lateral Raise (Band)", id: 333, active: false },
            { exercise: "Lateral Raise (Cable)", id: 334, active: false },
            { exercise: "Lateral Raise (Dumbbell)", id: 335, active: false },
            { exercise: "Lateral Raise (Machine)", id: 336, active: false },
            { exercise: "Overhead Press (Barbell)", id: 337, active: false },
            { exercise: "Overhead Press (Dumbbell)", id: 338, active: false },
            { exercise: "Overhead Press (Smith Machine)", id: 339, active: false },
            { exercise: "Plate Front Raise", id: 340, active: false },
            { exercise: "Push Press", id: 341, active: false },
            { exercise: "Reverse Pec Deck", id: 342, active: false },
            { exercise: "Seated Lateral Raise (Dumbbell)", id: 343, active: false },
            { exercise: "Seated Overhead Press (Barbell)", id: 344, active: false },
            { exercise: "Seated Overhead Press (Dumbbell)", id: 345, active: false },
            { exercise: "Seated Shoulder Press (Machine)", id: 346, active: false },
            { exercise: "Shoulder Press (Dumbbell)", id: 347, active: false },
            { exercise: "Shoulder Press (Machine Plates)", id: 348, active: false },
            { exercise: "Shoulder Taps", id: 349, active: false },
            { exercise: "Shrug", id: 350, active: false },
            { exercise: "Single Arm Landmine Press (Barbell)", id: 351, active: false },
            { exercise: "Single Arm Lateral Raise (Cable)", id: 352, active: false },
            { exercise: "Standing Military Press (Barbell)", id: 353, active: false },
            { exercise: "Upright Row (Cable)", id: 354, active: false },
            { exercise: "Upright Row (Dumbbell)", id: 355, active: false },
        ],

        traps: [
            { exercise: "Shrug (Barbell)", id: 382, active: false },
            { exercise: "Shrug (Cable)", id: 383, active: false },
            { exercise: "Shrug (Dumbbell)", id: 384, active: false },
            { exercise: "Shrug (Machine)", id: 385, active: false },
            { exercise: "Shrug (Smith Machine)", id: 386, active: false },
            { exercise: "Upright Row (Barbell)", id: 387, active: false },
        ],



    },

    legs: {
        hamstrings: [
            { exercise: "Deadlift (Band)", id: 215, active: false },
            { exercise: "Deadlift (Barbell)", id: 216, active: false },
            { exercise: "Deadlift (Dumbbell)", id: 217, active: false },
            { exercise: "Deadlift (Smith Machine)", id: 218, active: false },
            { exercise: "Deadlift (Trap bar)", id: 219, active: false },
            { exercise: "Glute Ham Raise", id: 220, active: false },
            { exercise: "Good Morning (Barbell)", id: 221, active: false },
            { exercise: "Lying Leg Curl (Machine)", id: 222, active: false },
            { exercise: "Nordic Hamstrings Curls", id: 223, active: false },
            { exercise: "Reverse Lunge (Dumbbell)", id: 224, active: false },
            { exercise: "Romanian Deadlift (Barbell)", id: 225, active: false },
            { exercise: "Romanian Deadlift (Dumbbell)", id: 226, active: false },
            { exercise: "Seated Leg Curl (Machine)", id: 227, active: false },
            { exercise: "Single Leg Romanian Deadlift (Barbell)", id: 228, active: false },
            { exercise: "Single Leg Romanian Deadlift (Dumbbell)", id: 229, active: false },
            { exercise: "Standing Leg Curls", id: 230, active: false },
            { exercise: "Straight Leg Deadlift", id: 231, active: false },
            { exercise: "Sumo Deadlift", id: 232, active: false }
        ],

        quadriceps: [
            { exercise: "Assisted Pistol Squats", id: 273, active: false },
            { exercise: "Box Jump", id: 274, active: false },
            { exercise: "Box Squat (Barbell)", id: 275, active: false },
            { exercise: "Bulgarian Split Squat", id: 276, active: false },
            { exercise: "Curtsy Lunge (Dumbbell)", id: 277, active: false },
            { exercise: "Dumbbell Step Up", id: 278, active: false },
            { exercise: "Front Squat", id: 279, active: false },
            { exercise: "Full Squat", id: 280, active: false },
            { exercise: "Goblet Squat", id: 281, active: false },
            { exercise: "Hack Squat", id: 282, active: false },
            { exercise: "Hack Squat (Machine)", id: 283, active: false },
            { exercise: "High Knee Skips", id: 284, active: false },
            { exercise: "Jump Squat", id: 285, active: false },
            { exercise: "Jumping Lunge", id: 286, active: false },
            { exercise: "Kettlebell Goblet Squat", id: 287, active: false },
            { exercise: "Lateral Box Jump", id: 288, active: false },
            { exercise: "Lateral Lunge", id: 289, active: false },
            { exercise: "Lateral Squat", id: 290, active: false },
            { exercise: "Leg Extension (Machine)", id: 291, active: false },
            { exercise: "Leg Press (Machine)", id: 292, active: false },
            { exercise: "Leg Press Horizontal (Machine)", id: 293, active: false },
            { exercise: "Lunge", id: 294, active: false },
            { exercise: "Lunge (Barbell)", id: 295, active: false },
            { exercise: "Lunge (Dumbbell)", id: 296, active: false },
            { exercise: "Overhead Dumbbell Lunge", id: 297, active: false },
            { exercise: "Pause Squat (Barbell)", id: 298, active: false },
            { exercise: "Pendulum Squat (Machine)", id: 299, active: false },
            { exercise: "Pistol Squat", id: 300, active: false },
            { exercise: "Reverse Lunge", id: 301, active: false },
            { exercise: "Reverse Lunge (Barbell)", id: 302, active: false },
            { exercise: "Single Leg Extensions", id: 303, active: false },
            { exercise: "Single Leg Press (Machine)", id: 304, active: false },
            { exercise: "Sissy Squat (Weighted)", id: 305, active: false },
            { exercise: "Split Squat (Dumbbell)", id: 306, active: false },
            { exercise: "Squat (Band)", id: 307, active: false },
            { exercise: "Squat (Barbell)", id: 308, active: false },
            { exercise: "Squat (Bodyweight)", id: 309, active: false },
            { exercise: "Squat (Dumbbell)", id: 310, active: false },
            { exercise: "Squat (Machine)", id: 311, active: false },
            { exercise: "Squat (Smith Machine)", id: 312, active: false },
            { exercise: "Squat (Suspension)", id: 313, active: false },
            { exercise: "Step Up", id: 314, active: false },
            { exercise: "Sumo Squat", id: 315, active: false },
            { exercise: "Sumo Squat (Barbell)", id: 316, active: false },
            { exercise: "Sumo Squat (Dumbbell)", id: 317, active: false },
            { exercise: "Sumo Squat (Kettlebell)", id: 318, active: false },
            { exercise: "Walking Lunge", id: 319, active: false },
            { exercise: "Walking Lunge (Dumbbell)", id: 320, active: false },
            { exercise: "Wall Sit", id: 321, active: false },
            { exercise: "Zercher Squat", id: 322, active: false },
        ],

        abductors: [
            { exercise: "Hip Abduction (Machine)", id: 49, active: false },
        ],

        Adductors: [
            { exercise: "Hip Adduction(Machine)", id: 50, active: false },
        ],

        calves: [
            { exercise: "Calf Extension (Machine)", id: 180, active: false },
            { exercise: "Calf Press (Machine)", id: 181, active: false },
            { exercise: "Seated Calf Raise", id: 182, active: false },
            { exercise: "Single Leg Standing Calf Raise", id: 183, active: false },
            { exercise: "Single Leg Standing Calf Raise (Barbell)", id: 184, active: false },
            { exercise: "Single Leg Standing Calf Raise (Dumbbell)", id: 185, active: false },
            { exercise: "Single Leg Standing Calf Raise (Machine)", id: 186, active: false },
            { exercise: "Standing Calf Raise", id: 187, active: false },
            { exercise: "Standing Calf Raise (Barbell)", id: 188, active: false },
            { exercise: "Standing Calf Raise (Dumbbell)", id: 189, active: false },
            { exercise: "Standing Calf Raise (Machine)", id: 190, active: false },
            { exercise: "Standing Calf Raise (Smith)", id: 191, active: false }
        ],

        glutes: [
            { exercise: "Bird Dog", id: 196, active: false },
            { exercise: "Cable Pull Through", id: 197, active: false },
            { exercise: "Clamshell", id: 198, active: false },
            { exercise: "Fire Hydrants", id: 199, active: false },
            { exercise: "Frog Pumps (Dumbbell)", id: 200, active: false },
            { exercise: "Glute Bridge", id: 201, active: false },
            { exercise: "Glute Kickback (Machine)", id: 202, active: false },
            { exercise: "Glute Kickback on Floor", id: 203, active: false },
            { exercise: "High Knees", id: 204, active: false },
            { exercise: "Hip Thrust", id: 205, active: false },
            { exercise: "Hip Thrust (Barbell)", id: 206, active: false },
            { exercise: "Hip Thrust (Machine)", id: 207, active: false },
            { exercise: "Lateral Band Walks", id: 208, active: false },
            { exercise: "Lateral Leg Raises", id: 209, active: false },
            { exercise: "Reverse Hyperextension", id: 210, active: false },
            { exercise: "Single Leg Glute Bridge", id: 211, active: false },
            { exercise: "Single Leg Hip Thrust", id: 212, active: false },
            { exercise: "Single Leg Hip Thrust (Dumbbell)", id: 213, active: false },
            { exercise: "Standing Cable Glute Kickbacks", id: 214, active: false }
        ],

    },

    core: {

        abdominals: [
            { exercise: "Ab Scissors", id: 1, active: false },
            { exercise: "Ab Wheel", id: 2, active: false },
            { exercise: "Bicycle Crunch", id: 3, active: false },
            { exercise: "Bicycle Crunch Raised Legs", id: 4, active: false },
            { exercise: "Cable Core Palloff Press", id: 5, active: false },
            { exercise: "Cable Crunch", id: 6, active: false },
            { exercise: "Cable Twist (Down to up)", id: 7, active: false },
            { exercise: "Cable Twist (Up to down)", id: 8, active: false },
            { exercise: "Crunch", id: 9, active: false },
            { exercise: "Crunch (Machine)", id: 10, active: false },
            { exercise: "Crunch (Weighted)", id: 11, active: false },
            { exercise: "Dead Bug", id: 12, active: false },
            { exercise: "Decline Crunch", id: 13, active: false },
            { exercise: "Decline Crunch (Weighted)", id: 14, active: false },
            { exercise: "Dragon Flag", id: 15, active: false },
            { exercise: "Dragonfly", id: 16, active: false },
            { exercise: "Elbow to Knee", id: 17, active: false },
            { exercise: "Flutter Kicks", id: 18, active: false },
            { exercise: "Front Lever Hold", id: 19, active: false },
            { exercise: "Front Lever Raise", id: 20, active: false },
            { exercise: "Hanging Knee Raise", id: 21, active: false },
            { exercise: "Hanging Leg Raise", id: 22, active: false },
            { exercise: "Heel Taps", id: 23, active: false },
            { exercise: "Hollow Rock", id: 24, active: false },
            { exercise: "Jack Knife (Suspension)", id: 25, active: false },
            { exercise: "Jackknife Sit Up", id: 26, active: false },
            { exercise: "Knee Raise Parallel Bars", id: 27, active: false },
            { exercise: "L-Sit Hold", id: 28, active: false },
            { exercise: "Landmine 180", id: 29, active: false },
            { exercise: "Leg Raise Parallel Bars", id: 30, active: false },
            { exercise: "Lying Knee Raise", id: 31, active: false },
            { exercise: "Lying Leg Raise", id: 32, active: false },
            { exercise: "Oblique Crunch", id: 33, active: false },
            { exercise: "Plank", id: 34, active: false },
            { exercise: "Reverse Crunch", id: 35, active: false },
            { exercise: "Reverse Plank", id: 36, active: false },
            { exercise: "Russian Twist (Bodyweight)", id: 37, active: false },
            { exercise: "Russian Twist (Weighted)", id: 38, active: false },
            { exercise: "Side Bend", id: 39, active: false },
            { exercise: "Side Bend (Dumbbell)", id: 40, active: false },
            { exercise: "Side Plank", id: 41, active: false },
            { exercise: "Sit Up", id: 42, active: false },
            { exercise: "Sit Up (Weighted)", id: 43, active: false },
            { exercise: "Spiderman", id: 44, active: false },
            { exercise: "Toe Touch", id: 45, active: false },
            { exercise: "Toes to Bar", id: 46, active: false },
            { exercise: "Torso Rotation", id: 47, active: false },
            { exercise: "V Up", id: 48, active: false },

        ],

    },

    cardio: {

        cardio: [
            { exercise: "Aerobics", id: 112, active: false },
            { exercise: "Air Bike", id: 113, active: false },
            { exercise: "Battle Ropes", id: 114, active: false },
            { exercise: "Boxing", id: 115, active: false },
            { exercise: "Climbing", id: 116, active: false },
            { exercise: "Cycling", id: 117, active: false },
            { exercise: "Elliptical Trainer", id: 118, active: false },
            { exercise: "HIIT", id: 119, active: false },
            { exercise: "Hiking", id: 120, active: false },
            { exercise: "Jump Rope", id: 121, active: false },
            { exercise: "Rowing Machine", id: 122, active: false },
            { exercise: "Running", id: 123, active: false },
            { exercise: "Skating", id: 124, active: false },
            { exercise: "Skiing", id: 125, active: false },
            { exercise: "Snowboarding", id: 126, active: false },
            { exercise: "Spinning", id: 127, active: false },
            { exercise: "Sprints", id: 128, active: false },
            { exercise: "Stair Machine", id: 129, active: false },
            { exercise: "Swimming", id: 130, active: false },
            { exercise: "Treadmill", id: 131, active: false },
            { exercise: "Walking", id: 132, active: false }

        ],
    },

    other: {
        neck: [
            { exercise: "Lying Neck Curls", id: 388, active: false },
            { exercise: "Lying Neck Curls (Weighted)", id: 389, active: false },
            { exercise: "Lying Neck Extension", id: 390, active: false },
            { exercise: "Lying Neck Extension (Weighted)", id: 391, active: false },
        ],

        full_body: [
            { exercise: "Ball Slams", id: 392, active: false },
            { exercise: "Burpee", id: 393, active: false },
            { exercise: "Burpee Over the Bar", id: 394, active: false },
            { exercise: "Clean", id: 395, active: false },
            { exercise: "Clean and Jerk", id: 396, active: false },
            { exercise: "Clean and Press", id: 397, active: false },
            { exercise: "Clean Pull", id: 398, active: false },
            { exercise: "Deadlift High Pull", id: 399, active: false },
            { exercise: "Downward Dog", id: 400, active: false },
            { exercise: "Dumbbell Snatch", id: 401, active: false },
            { exercise: "Farmers Walk", id: 402, active: false },
            { exercise: "Frog Jumps", id: 403, active: false },
            { exercise: "Handstand Hold", id: 404, active: false },
            { exercise: "Hang Clean", id: 405, active: false },
            { exercise: "Hang Snatch", id: 406, active: false },
            { exercise: "Jump Shrug", id: 407, active: false },
            { exercise: "Jumping Jack", id: 408, active: false },
            { exercise: "Kettlebell Clean", id: 409, active: false },
            { exercise: "Kettlebell High Pull", id: 410, active: false },
            { exercise: "Kettlebell Shoulder Press", id: 411, active: false },
            { exercise: "Kettlebell Snatch", id: 412, active: false },
            { exercise: "Kettlebell Swing", id: 413, active: false },
            { exercise: "Kettlebell Turkish Get Up", id: 414, active: false },
            { exercise: "Landmine Squat and Press", id: 415, active: false },
            { exercise: "Mountain Climber", id: 416, active: false },
            { exercise: "Muscle Up", id: 417, active: false },
            { exercise: "One Arm Push Up", id: 418, active: false },
            { exercise: "Overhead Squat", id: 419, active: false },
            { exercise: "Pilates", id: 420, active: false },
            { exercise: "Power Clean", id: 421, active: false },
            { exercise: "Power Snatch", id: 422, active: false },
            { exercise: "Press Under", id: 423, active: false },
            { exercise: "Sled Push", id: 424, active: false },
            { exercise: "Snatch", id: 425, active: false },
            { exercise: "Split Jerk", id: 426, active: false },
            { exercise: "Squat Row", id: 427, active: false },
            { exercise: "Thruster (Barbell)", id: 428, active: false },
            { exercise: "Thruster (Kettlebell)", id: 429, active: false },
            { exercise: "Wall Ball", id: 430, active: false },
            { exercise: "Warm Up", id: 431, active: false },
            { exercise: "Yoga", id: 432, active: false },
        ],

        other: [
            { exercise: "Stretching", id: 433, active: false },
        ],
    },









}



//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

export async function clear_LDB() {
    db[WORKOUT_TABLE].clear()
        .then(() => {
            console.log("All entries have been deleted successfully!");
        })
        .catch((error) => {
            console.error("Error deleting entries:", error);
        });

}



//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

export async function add_single_LDB(e) {


    // Collect data manually
    const formData = {
        title: e.target.title.value,
        start_time: e.target.start_time.value,
        end_time: e.target.end_time.value,
        description: e.target.description.value,
        exercise_title: e.target.exercise_title.value,
        set_index: e.target.set_index.value,
        set_type: e.target.set_type.value,
        weight_kg: e.target.weight_kg.value,
        reps: e.target.reps.value,
    };



    // Add the entry to the local table (WORKOUT_TABLE)
    db[WORKOUT_TABLE].add(formData)
        .then(() => {
            console.log("Entry added successfully!");
        })
        .catch((error) => {
            console.error("Error adding entry:", error);
        });


}



//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

export async function log_all_LDB() {
    try {
        // Fetch all entries from the WorkoutTable
        const allData = await db[WORKOUT_TABLE].toArray();

        if (allData.length > 0) {
            console.log("All data from WorkoutTable:", allData);
        } else {
            console.log("No data available in WorkoutTable.");
        }
    } catch (error) {
        console.error("Error fetching data from WorkoutTable:", error);
    }
}



//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

export async function populate_LDB() { // this can return empty array
    try {
        // Fetch all entries from the WorkoutTable
        const allData = await db[WORKOUT_TABLE].toArray();

        console.log("populate returning data:", allData)

        if (allData.length > 0) {
            console.log("Populating Table LDB: found data count:", allData.length);
            return allData;

        } else {
            console.log("No data available in WorkoutTable.");
            return [];
        }




    } catch (error) {
        console.error("Error fetching data from table:", error);
        return [];
    }
}



export async function add_bulk_LDB(entries) {


    try {
        // Perform the bulk insert into Dexie database
        await db[WORKOUT_TABLE].bulkAdd(entries);
        console.log('Batch insert completed into Dexie');
    } catch (error) {
        console.error('Error in batch insert into Dexie:', error);
    }

}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------


export async function get_data(from, to) {

    if (isNaN(new Date(from)) || isNaN(new Date(to))) {
        console.error('Invalid date range:', from, to);
        return;
    }

    try {
        const data = await db[WORKOUT_TABLE].where('start_date').between(from, to).toArray();
        return data;
    } catch (error) {
        console.error('Error in get_data:', error);
    }

}



export async function get_data_of_exercise(from, to, exercise) {

    if (isNaN(new Date(from)) || isNaN(new Date(to))) {
        console.error('Invalid date range:', from, to);
        return;
    }

    const from_date = new Date(from).toISOString();
    const to_date = new Date(to).toISOString();

    //   console.log('from_date : ', from_date);
    //  console.log('to_date : ', to_date);
    // console.log('exercise fetching : ', exercise);

    try {

        const data = await db[WORKOUT_TABLE]
            .where('start_time')
            .between(from_date, to_date)
            .filter(record => record.exercise_title === exercise)
            .toArray();

        //    console.log('data before returning: ', data);

        return data;
    } catch (error) {
        console.error('Error in get_data:', error);
        return []; // Return empty array on error
    }

}


export async function get_excercise_category_array() {


    const userExercises = await db[WORKOUT_TABLE]
        .orderBy('exercise_title')
        .uniqueKeys();

    //  console.log('userExercises: ', userExercises);


    // Step 1: Add categories to user exercises
    const userExercisesWithCategories = userExercises.map(exercise => {
        const match = exerciseCategories.find(item => item.exercise === exercise);
        return {
            exercise,
            category: match ? match.category : "Uncategorized"
        };
    });

    // Step 2: Group exercises by category
    const groupedByCategory = userExercisesWithCategories.reduce((acc, { exercise, category }) => {
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(exercise);
        return acc;
    }, {});

    // console.log('groupedByCategory: ', groupedByCategory);


    return Object.entries(groupedByCategory).map(([category, exercises]) => ({
        category,
        exercises
    }));




}



